import { Posto } from '../posto.model';

export class CaixaDTO {
  posto: Posto;
  dataHoraAbertura: number;
}
